import { SVGProps, Ref, forwardRef } from 'react';

export const ImageFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.334 16c0-12.833 1.833-14.667 14.667-14.667S30.667 3.167 30.667 16c0 2.456-.067 4.51-.265 6.224l-7.107-5.869-4.87 3.828-7.29-5.72-9.534 7.771c-.2-1.716-.267-3.773-.267-6.234m.769 8.922C3.47 29.78 7.075 30.667 16 30.667s12.53-.887 13.898-5.745l-6.64-5.485-4.832 3.797-7.263-5.698zM18.334 10c0-1.167.583-2.333 2.333-2.333S23.001 8.833 23.001 10s-.584 2.333-2.334 2.333-2.333-1.166-2.333-2.333"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageFilledSize32Glyph.displayName = 'ImageFilledSize32Glyph';
